import { getAvailableChartTypes } from '@meitu/saas-editor-core/es/layers/chart-layer/utils/core';
import { ChartType } from '@meitu/saas-editor-core/es/version-types';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import ChartCommonSelect from '../chart-common-select';

const ChartTypeSelector: React.FC<{
    chartType: ChartType;
    onChangeChartType: (chartType: ChartType) => void;
    onTrack: (type: 'isClick' | 'isUse') => void;
}> = ({ chartType, onChangeChartType, onTrack }) => {
    const { $t } = useLocaleStore();
    const availableChartTypes = getAvailableChartTypes(chartType, true);
    if (!availableChartTypes.length) return null;

    const iconMap: Record<ChartType, string> = {
        'bar-basic': 'BarChart',
        'bar-stacked': 'StackedColumnGraph',
        'bar-horizontal-basic': 'BarGraph',
        'bar-horizontal-stacked': 'StackedBarGragh',
        'line-basic': 'LineGraph',
        'pie-basic': 'Proportion',
        'pie-doughnut': 'DonutChart',
    };

    return (
        <ChartCommonSelect
            value={chartType}
            options={availableChartTypes.map((type) => ({
                value: type,
                label: (
                    <>
                        <IconFont name={iconMap[type]} fontSize={16} style={{ marginRight: 6 }} />
                        {$t((v) => v.chartLayer.panel.typeSection.typeMap[type])}
                    </>
                ),
            }))}
            suffixIcon={<IconFont name="ChevronDownBlack" fontSize={10} color="var(--content-input-label)" />}
            onChange={(type) => {
                onChangeChartType(type);
                onTrack('isUse');
            }}
            onDropdownVisibleChange={(visible) => visible && onTrack('isClick')}
        />
    );
};

ChartTypeSelector.displayName = 'ChartTypeSelector';

export default ChartTypeSelector;
